import React from "react";
import { MdInsertComment } from "react-icons/md";
import AttachmentPopover from "../../../pages/employee_details/InvestmentsAndProofs/components/AttachmentPopover";
import ApprovalField from "./ApprovalField";

const OtherIncomeSection = ({
  otherSourceIncome,
  attachments,
  onFileSelect,
  onAddMoreAttachments,
  onRemoveAttachment,
  onOpenImage,
  openPopoverKey,
  setOpenPopoverKey,
  onCommentClick,
  onApproval,
  onRejection,
  isApproving,
  isRejecting,
}) => {
  if (!otherSourceIncome) return null;

  const incomeFields = [
    {
      key: "income_from_other_sources",
      label: "Income from other sources",
      amount: otherSourceIncome.income_from_other_sources,
      approvedAmount: otherSourceIncome.int_other_soc_approved_amount,
      approvalKey: "int_other_soc_approved_amount",
      status: otherSourceIncome.income_from_other_sources_status,
    },
    {
      key: "interest_from_savings",
      label: "Interest Earned from Savings Deposit",
      amount: otherSourceIncome.interest_from_savings,
      approvedAmount: otherSourceIncome.int_sav_approved_amount,
      approvalKey: "int_sav_approved_amount",
      status: otherSourceIncome.interest_from_savings_status,
    },
    {
      key: "interest_from_fixed_deposits",
      label: "Interest Earned from Fixed Deposit",
      amount: otherSourceIncome.interest_from_fixed_deposits,
      approvedAmount: otherSourceIncome.int_fd_approved_amount,
      approvalKey: "int_fd_approved_amount",
      status: otherSourceIncome.interest_from_fixed_deposits_status,
    },
    {
      key: "interest_from_national_savings",
      label: "Interest Earned from National Savings Certificates",
      amount: otherSourceIncome.interest_from_national_savings,
      approvedAmount: otherSourceIncome.int_nat_sav_approved_amount,
      approvalKey: "int_nat_sav_approved_amount",
      status: otherSourceIncome.interest_from_national_savings_status,
    },
  ];

  const fieldsWithValues = incomeFields.filter(field => 
    field.amount && parseFloat(field.amount) > 0
  );

  if (fieldsWithValues.length === 0) return null;

  const totalDeclared = fieldsWithValues.reduce((sum, field) => sum + parseFloat(field.amount), 0);
  const totalApproved = fieldsWithValues.reduce((sum, field) => sum + parseFloat(field.approvedAmount || 0), 0);

  return (
    <>
      <p className="text-lg mx-3 font-semibold">Other Income</p>
      <p className="mx-3 mt-1 mb-4 text-sm">
        Declared Amount: ₹{totalDeclared.toLocaleString()} | Approved Amount: ₹{totalApproved.toLocaleString()}
      </p>
      {fieldsWithValues.map((field, index) => (
        <div key={field.key} className="flex items-center mx-3 my-3">
          <div className="flex-no-grow-no-shrink px-1.5 w-[28.4%]">
            <p>{field.label}</p>
          </div>
          <div className="flex-no-grow-no-shrink px-1.5 w-[14.2%]">
            <p className="text-right text-sm">₹{parseFloat(field.amount).toLocaleString()}</p>
          </div>
          <div className="flex-no-grow-no-shrink px-1.5 w-[14.2%] grid place-items-center">
            <AttachmentPopover
              attachmentKey={`other-income-${field.key}`}
              attachments={attachments}
              onFileSelect={() =>
                onFileSelect(
                  `other-income-${field.key}`,
                  {
                    other_source_income_id: otherSourceIncome.other_source_income_id,
                    type: field.key,
                  },
                  otherSourceIncome.document_count?.[field.key] || 0
                )
              }
              onAddMoreAttachments={onAddMoreAttachments}
              onRemoveAttachment={onRemoveAttachment}
              onOpenImage={onOpenImage}
              openPopoverKey={openPopoverKey}
              setOpenPopoverKey={setOpenPopoverKey}
              documentCount={otherSourceIncome.document_count?.[field.key] || 0}
            />
          </div>
          <div className="flex-no-grow-no-shrink px-1.5 w-[14.2%] grid place-items-center">
            <button
              onClick={() =>
                onCommentClick(`other-income-${field.key}`, {
                  other_source_income_id: otherSourceIncome.other_source_income_id,
                  type: field.key,
                })
              }
              className="flex items-center"
            >
              <MdInsertComment className="w-5 h-5 text-neutral-600" />
              {(otherSourceIncome.comment_count?.[field.key] || 0) > 0 && (
                <span className="ml-1 text-xs text-gray-600">
                  {otherSourceIncome.comment_count[field.key]}
                </span>
              )}
            </button>
          </div>
          <ApprovalField
            approvedAmount={field.approvedAmount}
            actualAmount={parseFloat(field.amount)}
            onApproval={(data) => {
              onApproval({
                other_source_income_id: otherSourceIncome.other_source_income_id,
                [field.approvalKey]: data.amount_approved,
              });
            }}
            onRejection={() => {
              // For other source income, send the status parameter instead
              const statusKey = `${field.key}_status`;
              onRejection({
                other_source_income_id: otherSourceIncome.other_source_income_id,
                [statusKey]: "REJECTED",
              });
            }}
            approvalParams={{
              other_source_income_id: otherSourceIncome.other_source_income_id,
              [field.approvalKey]: field.approvedAmount,
            }}
            isApproving={isApproving}
            isRejecting={isRejecting}
            status={field.status}
          />
        </div>
      ))}
      <hr className="my-5 mx-3" />
    </>
  );
};

export default OtherIncomeSection;
